export interface ISuccessResponse
{
    success: boolean
    msg: string
}

export const SuccessResponse = {
    success: false,
    msg: ''
}